
import '../apply-rule-modal.css';
import React, { BaseSyntheticEvent, useState } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { observer } from 'mobx-react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { useEffect } from 'react';
import { Utility } from '../../../../../common/utility';
import { IAfterSaveRule, IAfterSaveRuleModalProps, ICriteria, IExtendedRule } from '../../ILayoutConfigurationPanel.Interface';
import { CommonRuleModal } from '../common-rule-modal';

const INITIAL_STATE = {
    field: '',
    operator: '',
    compareTo: '',
    isDynamic: false,
    selectedFieldType: '',
    referenceField: '',
    referenceTo: '',
    relationshipName:''
}
const utility = new Utility();

const AfterSaveRedirectToRulesModalComponent = (props: IAfterSaveRuleModalProps) => {
    const [state, setState] = useState(() => ({
        redirectTo : {
        addedCriterias: [INITIAL_STATE],
        query: '',
        complexLogicQuery: '1',
        complexLogicVisibility: false,
        shouldSkip: false
       }
    }));

    const [extraState, setExtraState] = useState<IExtendedRule>(() => ({
        additionalFields: [],
        fieldWisePicklistValues: [],
        selectedReferenceFields: [],
    }));

    const [shouldValidate, setShouldValidate] = useState(false);

    useEffect(() => {
        async  function intitializeState(){
            if (props.appliedRule) {
                const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
                const objectName: any = props.objectName;
                const redirectTo = ruleObject[objectName][props.appliedRule].redirectTo;
                const stateCopy  = utility.createObjectDeepCopy(extraState);
                stateCopy.additionalFields = ruleObject[objectName][props.appliedRule].additionalFields;
                stateCopy.fieldWisePicklistValues = ruleObject[objectName][props.appliedRule].fieldWisePicklistValues;
                stateCopy.selectedReferenceFields = ruleObject[objectName][props.appliedRule].selectedReferenceFields;
                if (redirectTo) {
                    setState({redirectTo});
                    setExtraState(stateCopy)
                }
            }
            props.checkValidation(validateAddRuleForm());
        }
        intitializeState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());
        props.checkValidation(validateAddRuleForm());

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraState]);

    function generateMergedStore(){
        return {...state, ...extraState};
    }

    /**
     * @description updates rule object and checks for validation for rule
     * @memberof AfterSaveRedirectToRulesModalComponent
     */
    function updateRuleObject(ruleObjectProperty: string, ruleObjectValue: any) {
        props.setRuleObject(ruleObjectValue);
        props.checkValidation(validateAddRuleForm());
    }
    
    /**
     * @description Used for validation for rule added for field type
     * @memberof AfterSaveRedirectToRulesModalComponent
     */
    function validateAddRuleForm() {
        if(!shouldValidate){
            return true;
        } 

        let isComplexLogicValid = false;
        let isQueryValid = false;
        let isCriteriaValid = false;
        isCriteriaValid = state.redirectTo.addedCriterias.every((criteria: ICriteria, index: number) =>
            (criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))
                && (( CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType)?
                 ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY || index === 0) ? true :
                 (criteria.referenceField !== '')) : true)
            ));

        if(state.redirectTo.shouldSkip){
            isCriteriaValid = true;
        }

        if (state.redirectTo.query !== "") {
            isQueryValid = true;
        }

        if (!isCriteriaValid || !isQueryValid || isComplexLogicValid) {
            return true;
        }

        return false;
    }

    /**
     * @description Updates value for query
     * @param e event that updates value of query
     * @param eventKey passes query as string to update value in state
     * @memberof AfterSaveRedirectToRulesModalComponent
     */
    function onTextChanged (e: BaseSyntheticEvent,eventKey: string){
        setValidation();
        const stateCopy :any = utility.createObjectDeepCopy(state);
        stateCopy.redirectTo[eventKey] = e.target.value;
        setState(stateCopy);
    };

    /**
     * @description Used to set validation true for new states
     * @param newState contains state copy
     */
    function updateState (newState:IAfterSaveRule) {
        setValidation();
        setState(newState);
    }

    /**
     * @description Used to validate rule
     */
    function setValidation() {
        if (!shouldValidate) {
            setShouldValidate(true);
        } 
    }
    
    return (
        <>
            <div className="slds-grid slds-grid_vertical">
                <CommonRuleModal
                    modalInfo= {{
                        shouldRenderAddComplexBtn: true,
                        shouldDisableFirstElement: false,
                        toggleModalVisibility: props.toggleModalVisibility
                    }}
                    parentAction= {{
                        updateState: (state:IAfterSaveRule) => updateState(state),
                        updateExtraState: (state: IExtendedRule) => setExtraState(state)
                    }}
                    parentInfo= {{
                        state:state.redirectTo,
                        extraState,
                        initialCriteria: INITIAL_STATE,
                        addFieldOnSkip: false,
                    }}
                    selectedRule='redirectTo'
                    objectName= {props.objectName}
                    templateName= {props.selectedTemplateName}
                /> 
                 <h3 className="slds-m-bottom_small">Query</h3>
                 <div className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                    <div className="slds-col slds-size_10-of-12">
                         <div className="slds-form-element">
                            <div className="slds-form-element__control">
                                <input
                                    id="query"
                                    type="text"
                                    className="slds-input"
                                    placeholder="Enter query"
                                    value={state.redirectTo.query}
                                    onChange={(e) => onTextChanged(e, 'query')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export const AfterSaveRedirectToRulesModal = observer(AfterSaveRedirectToRulesModalComponent);
